import CompanyService from '@/services/CompanyService'

const createCompaniesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    filter: '',
    companies: []
  },
  actions: {
    getCompanies: ({ commit, state }) => {
      CompanyService.getCompanies(state.pageSize, state.page, state.filter)
        .then((data) => {
          commit('SET_COMPANIES', { companies: data.companies })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPageSize: ({ commit }, pageSize) => {
      commit('SET_PAGE_SIZE', { pageSize })
    },
    setPage: ({ dispatch, commit }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getCompanies')
    },
    setFilter: ({ dispatch, commit }, filter) => {
      commit('SET_PAGE', { page: 1 })
      commit('SET_FILTER', { filter })
      dispatch('getCompanies')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    },
    companies: (state) => state.companies
  },
  mutations: {
    SET_COMPANIES: (state, { companies }) => {
      state.companies = companies
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_PAGE_SIZE: (state, { pageSize }) => {
      state.pageSize = pageSize
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    },
    SET_FILTER: (state, { filter }) => {
      state.filter = filter
    }
  }
})

export default createCompaniesModule
